<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-text>
            <async-form :form-data="formData" @submit="createQrCode">
              <text-field :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" icon-left="qrcode" :placeholder="$lang.typeSomeTextAndHitEnter" v-model="formData.text" />
            </async-form>
          </card-text>
          <card-actions align="center">
            <qr-code @ready="onReady" :size="200" :block="false" :text="formData.text" />
          </card-actions>
          <divider />
          <card-actions align="center">
            <code-chunk :pre="false">"text": "{{ formData.text }}"</code-chunk>
          </card-actions>
        </card>
      </flex-col>
      <flex-col :span="8" sm24 md12 v-for="(qrCode, index) in qrCodes" :key="index">
        <card align="center">
          <card-title v-html="qrCode.outputMode.toUpperCase()" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" />
          <card-text>
            <qr-code @ready="onReady" :output-mode="qrCode.outputMode" :size="200" :block="false" :text="qrCode.text" />
          </card-text>
          <divider />
          <card-actions align="center">
            <code-chunk :pre="false">"text": "{{ qrCode.text }}"</code-chunk>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageQrCode',
  mixins: [
    methods
  ],
  data () {
    return {
      qrCodes: [],
      formData: {
        text: this.$lang.typeSomeTextAndHitEnter
      }
    }
  },
  mounted () {
    this.getExternalData('qr-code.json', 'qrCodes')
  },
  methods: {
    onReady ($event) {
      this.log('@ready', 'qr-ready', $event)
    },
    createQrCode () {
      console.log(this.formData.text)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/qr-code.vue